/* MYPARF — Quick Order popup logic (Buy Now / Order Now).
   Talks ONLY to the public Supabase Edge Function endpoint (no Shopify Admin
   credentials ever touch this file). The endpoint re-validates price/stock
   server-side; this file never trusts its own totals for the real charge —
   it only mirrors them for the customer's live preview. */
(function () {
  var root = document.getElementById('myparf-quick-order');
  if (!root) return;

  var ENDPOINT = root.dataset.endpoint;
  var LOCALE = root.dataset.locale || 'fr';
  var overlay = root;
  var formState = root.querySelector('[data-qo-state="form"]');
  var successState = root.querySelector('[data-qo-state="success"]');
  var itemsEl = root.querySelector('[data-qo-items]');
  var subtotalEl = root.querySelector('[data-qo-subtotal]');
  var shippingEl = root.querySelector('[data-qo-shipping]');
  var totalEl = root.querySelector('[data-qo-total]');
  var form = root.querySelector('[data-qo-form]');
  var submitBtn = root.querySelector('[data-qo-submit]');
  var formErrorEl = root.querySelector('[data-qo-form-error]');
  var successHeading = root.querySelector('[data-qo-success-heading]');
  var recapEl = root.querySelector('[data-qo-recap]');
  /* V2 success redesign (2026-09-14, display only) */
  var orderNumberEl = root.querySelector('[data-qo-order-number]');
  var recapSubEl = root.querySelector('[data-qo-recap-subtotal]');
  var recapShipEl = root.querySelector('[data-qo-recap-shipping]');
  var recapTotalEl = root.querySelector('[data-qo-recap-total]');

  var strings = (window.myparfQuickOrderStrings || {});
  var FREE_SHIPPING_THRESHOLD = 500;
  var SHIPPING_FEE = 35;

  var currentItems = [];
  var currentMode = null;
  var submitting = false;

  function t(key) {
    return strings[key] || key;
  }

  function money(amount) {
    // OWNER-APPROVED PATCH (2026-09-13, display only): group thousands and drop
    // ".00" so the modal matches the storefront's money_without_trailing_zeros
    // ("1,019 dh"). Amount math is untouched; the server re-validates prices.
    var format = root.dataset.moneyFormat || '{{amount}} MAD';
    var fixed = (Math.round(amount * 100) / 100).toFixed(2);
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var display = parts[1] === '00' ? parts[0] : parts.join('.');
    return format.replace(/\{\{\s*amount\s*\}\}/, display).replace('amount', display);
  }

  function normalizePhoneClientSide(raw) {
    var digits = String(raw || '').replace(/[\s.\-()]/g, '');
    var re = /^(?:(?:\+|00)212[67]\d{8}|0[67]\d{8})$/;
    return re.test(digits);
  }

  function computeTotals(items) {
    var subtotal = items.reduce(function (sum, it) { return sum + it.price * it.quantity; }, 0);
    var shipping = subtotal >= FREE_SHIPPING_THRESHOLD ? 0 : SHIPPING_FEE;
    return { subtotal: subtotal, shipping: shipping, total: subtotal + shipping };
  }

  function renderItems(items) {
    itemsEl.innerHTML = '';
    items.forEach(function (it) {
      var row = document.createElement('div');
      row.className = 'qo-item';
      row.innerHTML =
        '<div class="qo-item__image">' +
          (it.image ? '<img src="' + it.image + '" alt="" loading="lazy">' : '') +
        '</div>' +
        '<div>' +
          '<div class="qo-item__title">' + escapeHtml(it.title) + (it.variantTitle && it.variantTitle !== 'Default Title' ? ' — ' + escapeHtml(it.variantTitle) : '') + '</div>' +
          '<div class="qo-item__meta">' + escapeHtml(it.vendor || '') + ' · ' + t('summary_qty_short') + ' ' + it.quantity + '</div>' +
        '</div>' +
        '<div class="qo-item__line">' + money(it.price * it.quantity) + '</div>';
      itemsEl.appendChild(row);
    });
  }

  function renderTotals(items) {
    var totals = computeTotals(items);
    subtotalEl.textContent = money(totals.subtotal);
    shippingEl.textContent = totals.shipping === 0 ? t('summary_shipping_free') : money(totals.shipping);
    totalEl.textContent = money(totals.total);
    return totals;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function showState(name) {
    formState.hidden = name !== 'form';
    successState.hidden = name !== 'success';
  }

  function clearFieldErrors() {
    root.querySelectorAll('[data-qo-error]').forEach(function (el) { el.textContent = ''; });
    formErrorEl.hidden = true;
    formErrorEl.textContent = '';
  }

  function setFieldError(field, message) {
    var el = root.querySelector('[data-qo-error="' + field + '"]');
    if (el) el.textContent = message;
  }

  function open(mode, payload) {
    currentMode = mode;
    clearFieldErrors();
    form.reset();
    showState('form');

    if (mode === 'buynow') {
      currentItems = [payload];
      renderItems(currentItems);
      renderTotals(currentItems);
      overlay.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    } else {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart.items || !cart.items.length) return;
          currentItems = cart.items.map(function (li) {
            return {
              variantId: 'gid://shopify/ProductVariant/' + li.variant_id,
              quantity: li.quantity,
              title: li.product_title,
              variantTitle: li.variant_title,
              vendor: li.vendor,
              price: li.price / 100,
              image: li.image,
            };
          });
          renderItems(currentItems);
          renderTotals(currentItems);
          overlay.hidden = false;
          document.documentElement.style.overflow = 'hidden';
        });
    }
  }

  function close() {
    overlay.hidden = true;
    document.documentElement.style.overflow = '';
  }

  root.querySelectorAll('[data-qo-close]').forEach(function (btn) {
    btn.addEventListener('click', close);
  });
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !overlay.hidden) close();
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (submitting) return;
    clearFieldErrors();

    var data = new FormData(form);
    var name = String(data.get('name') || '').trim();
    var phone = String(data.get('phone') || '').trim();
    var address = String(data.get('address') || '').trim();
    var website = String(data.get('website') || '').trim(); // honeypot

    var valid = true;
    if (name.length < 3) { setFieldError('name', t('error_name')); valid = false; }
    if (!normalizePhoneClientSide(phone)) { setFieldError('phone', t('error_phone')); valid = false; }
    if (address.length < 3) { setFieldError('address', t('error_address')); valid = false; }
    if (!valid) return;

    submitting = true;
    submitBtn.setAttribute('data-loading', '');
    submitBtn.disabled = true;

    var idempotencyKey = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() :
      (Date.now() + '-' + Math.random().toString(36).slice(2));

    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        locale: LOCALE,
        name: name,
        phone: phone,
        address: address,
        website: website,
        items: currentItems.map(function (it) { return { variantId: it.variantId, quantity: it.quantity }; }),
        idempotencyKey: idempotencyKey,
      }),
    })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        submitting = false;
        submitBtn.removeAttribute('data-loading');
        submitBtn.disabled = false;

        if (!res.ok) {
          formErrorEl.hidden = false;
          formErrorEl.textContent = res.body && res.body.error ? res.body.error : t('error_generic');
          return;
        }

        var order = res.body;
        /* V2 success redesign (2026-09-14) — DISPLAY ONLY: same server fields
           (orderNumber, items[{title,quantity,lineTotal}], subtotal, shipping,
           total) rendered into the new premium confirmation layout. */
        if (successHeading) {
          successHeading.textContent = t('success_heading').replace('{order_number}', order.orderNumber);
        }
        if (orderNumberEl) {
          orderNumberEl.textContent = t('success_order').replace('{order_number}', order.orderNumber || '');
          orderNumberEl.hidden = !order.orderNumber;
        }
        recapEl.innerHTML = '';
        (order.items || []).forEach(function (it, idx) {
          var parts = String(it.title || '').split(' — ');
          var itemName = parts[0];
          var variantPart = parts.slice(1).join(' — ');
          /* OWNER-APPROVED (2026-09-15, display only): the real server title
             carries no variant — reuse the variantTitle already known client
             side (same source as the pre-submit recap). No payload change. */
          if (!variantPart && currentItems && currentItems[idx] && currentItems[idx].variantTitle && currentItems[idx].variantTitle !== 'Default Title') {
            variantPart = currentItems[idx].variantTitle;
          }
          var meta = (variantPart ? variantPart + ' · ' : '') + t('summary_qty_short') + ' ' + it.quantity;
          var row = document.createElement('div');
          row.className = 'qo-done__item';
          row.innerHTML =
            '<span class="qo-done__item-info">' +
              '<span class="qo-done__item-name">' + escapeHtml(itemName) + '</span>' +
              '<span class="qo-done__item-meta">' + escapeHtml(meta) + '</span>' +
            '</span>' +
            '<span class="qo-done__item-line">' + money(it.lineTotal) + '</span>';
          recapEl.appendChild(row);
        });
        if (recapSubEl) recapSubEl.textContent = money(order.subtotal);
        if (recapShipEl) recapShipEl.textContent = order.shipping === 0 ? t('summary_shipping_free') : money(order.shipping);
        if (recapTotalEl) recapTotalEl.textContent = money(order.total);

        showState('success');

        if (currentMode === 'cart') {
          fetch('/cart/clear.js', { method: 'POST' }).then(function () {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          });
        }
      })
      .catch(function () {
        submitting = false;
        submitBtn.removeAttribute('data-loading');
        submitBtn.disabled = false;
        formErrorEl.hidden = false;
        formErrorEl.textContent = t('error_network');
      });
  });

  window.MyParfQuickOrder = { open: open, close: close };

  // Wire up triggers already in the DOM (buy-now button on PDP, order-now in cart).
  document.addEventListener('click', function (e) {
    var buyNowBtn = e.target.closest('[data-qo-buy-now]');
    if (buyNowBtn) {
      e.preventDefault();
      var formEl = buyNowBtn.closest('form');

      // Quantity: read the live selector, not a static attribute.
      // OWNER-APPROVED PATCH (2026-09-13): Dawn renders the quantity input
      // OUTSIDE the <form>, associated via its form= attribute — querySelector
      // on the form never finds it. form.elements DOES include it.
      var qtyInput = formEl && (formEl.elements['quantity'] || formEl.querySelector('.quantity__input, input[name="quantity"]'));
      var liveQty = qtyInput ? parseInt(qtyInput.value, 10) : NaN;

      // Variant: MUST come from the form's live hidden input, which Dawn rewrites
      // whenever the customer changes a size/option. The data- attribute is rendered
      // once by Liquid and would order the ORIGINAL variant on a multi-size product.
      var idInput = formEl && formEl.querySelector('input[name="id"]');
      var liveVariantId = (idInput && idInput.value) ? idInput.value.trim()
                                                     : buyNowBtn.dataset.qoVariantId;

      var payload = {
        variantId: 'gid://shopify/ProductVariant/' + liveVariantId,
        quantity: (liveQty && liveQty > 0) ? liveQty : parseInt(buyNowBtn.dataset.qoQuantity || '1', 10),
        title: buyNowBtn.dataset.qoTitle || '',
        vendor: buyNowBtn.dataset.qoVendor || '',
        price: parseInt(buyNowBtn.dataset.qoPrice || '0', 10) / 100,
        image: buyNowBtn.dataset.qoImage || '',
        variantTitle: '',
      };

      // Resolve the selected variant's real size + price from Shopify's own product
      // JSON so the popup preview matches the variant actually being ordered.
      // (The server re-verifies price regardless; this only fixes what the customer sees.)
      var handle = buyNowBtn.dataset.qoHandle;
      if (handle && liveVariantId) {
        fetch('/products/' + handle + '.js')
          .then(function (r) { return r.json(); })
          .then(function (p) {
            var v = (p.variants || []).filter(function (x) { return String(x.id) === String(liveVariantId); })[0];
            if (v) {
              payload.price = v.price / 100;
              payload.variantTitle = (v.title && v.title !== 'Default Title') ? v.title : '';
              if (v.featured_image && v.featured_image.src) payload.image = v.featured_image.src;
            }
            open('buynow', payload);
          })
          .catch(function () { open('buynow', payload); });
      } else {
        open('buynow', payload);
      }
      return;
    }
    var cartBtn = e.target.closest('[data-qo-cart-order]');
    if (cartBtn) {
      e.preventDefault();
      open('cart', null);
    }
  });
})();
